import { background, borderColor, brandPrimary, navigation } from '../../../../web/styles/colors';
import { DefaultBorder } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	root: {
		paddingTop: '1rem',
	},
	tabList: {
		':first-child': {
			borderTopLeftRadius: 3,
		},
		':last-child': {
			borderTopRightRadius: 3,
		},
		borderBottom: `1px solid ${borderColor}`,
		display: 'flex',
		height: 44,
		padding: '0 4rem',
	},
	tabTrigger: {
		alignItems: 'center',
		background,
		border: DefaultBorder,
		boxSizing: 'border-box',
		color: navigation,
		display: 'flex',
		fontSize: '0.875rem',
		justifyContent: 'center',
		minWidth: '10rem',
		padding: '0.5rem 1rem',
		textTransform: 'uppercase',
	},
	tabTriggerActive: {
		background: 'white',
		borderBottom: '1px solid white',
		boxShadow: '0 1px 0 0 white',
		color: brandPrimary,
	},
});
